module.exports = __webpack_public_path__ + "img/scene3-3.abaa6324.jpg";